import React from 'react';
import BaseApi from "../../utils/BaseApi";
import {CircularProgress, Modal, ModalClose, ModalDialog, Stack} from "@mui/joy";
import Box from "@mui/joy/Box";
import Typography from "@mui/joy/Typography";
import Divider from "@mui/joy/Divider";

// components
import EstimationPhaseCard from "./EstimationPhaseCard";
import EstimationPhaseCreate from "./EstimationPhaseCreate";
import CommonInfoTab from "../Common/CommonInfoTab";
import retrievePermission from "../../utils/retrievePermission";
import UserSubscriberContext from "../../context/UserSubscriberContext";

// icons
import IconButton from "@mui/joy/IconButton";
import WebAssetIcon from "@mui/icons-material/WebAsset";


class EstimationRevisionModal extends React.Component {
    static contextType = UserSubscriberContext

    constructor(props) {
        super(props);
        this.state = {
            phases: null,
            modalOpen: false,
            updatePermission: 0,
        };
    }

    async componentDidMount() {
        await this.retrievePhases();
        await this.retrieveUpdatePermission()
    }

    async setModalOpenTrue(){
        this.setState({
            modalOpen: true,
        })
        await this.retrievePhases();
    }

    setModalOpenFalse() {
        this.setState(
            {
                modalOpen: false,
            }
        )
    }

    async retrievePhases() {
        this.setState(
            {
                phases: null,
            }
        );
        const url = `estimation_phase/`;
        const api = new BaseApi();
        const params = {
            revision_fk: this.props.revision.id
        };
        let response = await api.get(
            url,
            params
        );
        this.setState(
            {
                phases: response.data.results
            }
        );
    }

    async retrieveUpdatePermission() {
        let p = await retrievePermission(
            'EstimationRevisionViewSet',
            'update',
            this.context.subscriberObject
        );
        this.setState(
            {
                updatePermission: p
            }
        );
    }

    render() {
        if (!this.state.phases) {
            return (<CircularProgress/>)
        }
        return (
            <Box
                sx={{
                    display: 'inline'
                }}
            >
                <IconButton
                    size={'sm'}
                    color="neutral"
                    onClick={this.setModalOpenTrue.bind(this)}
                >
                    <WebAssetIcon />
                </IconButton>
                <Modal
                    open={this.state.modalOpen}
                >
                    <ModalDialog
                        layout={'center'}
                        size="sm"
                    >
                        <ModalClose
                            onClick={this.setModalOpenFalse.bind(this)}
                        />
                        <Box
                            sx={{
                                overflowY: 'scroll',
                                width: 'calc(80vw)',
                                height: 'calc(80vh)',
                                pr: 2
                            }}
                        >
                            <Typography
                                level={'h4'}
                                sx={{
                                    mb: 2
                                }}
                            >
                                Ревизия №{this.props.revision.number}: {this.props.revision.desc}
                            </Typography>
                            <Stack>
                                {this.state.phases.map((each) => {
                                        return(
                                            <>
                                                <EstimationPhaseCreate
                                                    revisionId={this.props.revision.id}
                                                    opportunityId={this.props.revision.opportunity}
                                                    order={each.order}
                                                    callBack={this.retrievePhases.bind(this)}
                                                />
                                                <EstimationPhaseCard
                                                    phase={each}
                                                    callBack={this.retrievePhases.bind(this)}
                                                />
                                            </>
                                        )
                                    })
                                }
                            </Stack>
                            <EstimationPhaseCreate
                                revisionId={this.props.revision.id}
                                opportunityId={this.props.revision.opportunity}
                                order={this.state.phases.length ===0?1:(this.state.phases.slice(-1)[0].order+1)}
                                callBack={this.retrievePhases.bind(this)}
                            />
                            <Divider
                                sx={{
                                    mt: 2,
                                    mb: 2,
                                }}
                            />
                            <CommonInfoTab
                                callBack={this.props.callBack}
                                flat={true}
                                groups={
                                    [
                                        {
                                            title: '',
                                            icon: null,
                                            fields: [
                                                {
                                                    title: 'Описание',
                                                    value: this.props.revision.desc,
                                                    xs: 12,
                                                    sm: 12,
                                                    md: 12,
                                                    lg: 12,
                                                    edit: {
                                                        permission: this.state.updatePermission,
                                                        fields: ['desc', ],
                                                        baseUrl: 'estimation_revision',
                                                        obj: this.props.revision
                                                    }
                                                },
                                                {
                                                    title: 'Текст для ТКП',
                                                    value: this.props.revision.quote_text,
                                                    html: true,
                                                    xs: 12,
                                                    sm: 12,
                                                    md: 12,
                                                    lg: 12,
                                                    edit: {
                                                        permission: this.state.updatePermission,
                                                        fields: ['quote_text', ],
                                                        baseUrl: 'estimation_revision',
                                                        obj: this.props.revision
                                                    }
                                                },
                                            ]
                                        }
                                    ]
                                }
                            />
                        </Box>
                    </ModalDialog>
                </Modal>
            </Box>
        )
    }
}

export default EstimationRevisionModal